import { TIME_TYPES } from '@/constants/timeTypes'

/**
 * Строит базовый payload для запроса интервалов доставки/самовывоза/предзаказа
 * @param {Object} params
 * @param {string} params.timeType - Тип времени (asap, ontime, interval)
 * @param {string} params.brandCode - Код бренда
 * @param {string} params.dishType - Тип блюда (standard, cookery)
 * @param {number} params.price - Цена заказа
 * @param {string} params.estimatedDate - Планируемая дата доставки
 * @param {Object} params.locationParams - Параметры локации (coordinates или restaurant_rk_id)
 * @returns {Object} Payload для API
 */
export const buildIntervalsPayload = ({
    timeType,
    brandCode,
    dishType = 'standard',
    price,
    estimatedDate,
    locationParams = {},
}) => {
    if (!timeType) {
        throw new Error(
            'buildIntervalsPayload: обязательный параметр timeType не передан'
        )
    }
    if (!brandCode) {
        throw new Error(
            'buildIntervalsPayload: обязательный параметр brandCode не передан'
        )
    }
    if (price == null) {
        throw new Error(
            'buildIntervalsPayload: обязательный параметр price не передан'
        )
    }

    const payload = {
        time_type: timeType,
        brand_code: brandCode,
        dish_type: dishType,
        order: {
            payment: { price },
        },
        ...locationParams,
    }

    // Добавляем date_time для ontime/interval, если передана дата
    if (
        estimatedDate &&
        [TIME_TYPES.ontime, TIME_TYPES.interval].includes(timeType)
    ) {
        payload.date_time = estimatedDate
    }

    return payload
}

/**
 * Хелпер для построения параметров координат (для доставки)
 */
export const buildCoordinatesParams = (latitude, longitude) => ({
    coordinates: {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
    },
})

/**
 * Хелпер для построения параметров ресторана (для самовывоза/предзаказа)
 */
export const buildRestaurantParams = restaurantRkId => ({
    restaurant_rk_id: restaurantRkId,
})
